/// <reference path="../../_ext/Editors/BOMGridEditor.ts" />

namespace TabAurous.Inventory {

    import fld = SKUItemBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SKUItemBOMEditor extends _Ext.BOMGridEditor<SKUItemBOMRow> {

         
        protected getDialogType() { return SKUItemBOMDialog; }
        protected getLocalTextPrefix() { return SKUItemBOMRow.localTextPrefix; } 
        public pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: false });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = num;
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            //#   To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {
                        /*                        if (item.TransItemId > 0) {
                        
                                                    // **** Validate StockId from Stock Transactions ****
                                                    let StockID;
                                                    Stock.StockItemService.GetStockTransactions({
                                                        LineNo: item.Line_No,
                                                        TransId: item.TransId,
                                                        Product_Id: item.ProductId,
                                                        Take: 1
                                                    },
                                                        response => StockID = response.Entities.length,
                                                        {
                                                            async: false
                                                        });
                        
                                                    Q.alert
                                                    if (StockID > 0 || StockID != null) {
                                                        Q.alert("This Item is used in other transactions, Can Not Delete!!");
                                                        return;
                                                    }
                                                    else {
                                                        Purchase.SKUItemBOMService.Delete({ EntityId: item.TransItemId });
                                                        Stock.StockItemService.Delete({ EntityId: StockID });
                                                        var id = this.id(item);
                                                        this.TotalItems = this.view.getItems().length - 1;
                                                        this.view.deleteItem(id);
                                                    }*
                                                }
                                                else {*/
                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        //}

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        //public inputsChange(e: JQueryEventObject,) {
        //    var cell = this.slickGrid.getCellFromEvent(e);
        //    var item = this.itemAt(cell.row);
        //    var input = $(e.target);
        //    var field = input.data('field');
        //    var text = Q.coalesce(Q.trimToNull(input.val()), '0');
        //    var id = this.id(item);
        //    var pending = this.pendingChanges[id];

        //    // *** Format Number ***
        //    var effective = this.getEffectiveValue(item, field);
        //    var oldText: string = input.hasClass('numeric')
        //        ? Q.formatNumber(effective, '0.00')
        //        : effective as string;

        //    var value;
        //    // *** Validate Decimal & Integer***
        //    if (field === fld.Pieces) {
        //        value = Q.parseDecimal(text);
        //        if (value == null || isNaN(value)) {
        //            Q.notifyError(Q.text('Validation.Decimal'), '', null);
        //            input.val(oldText);
        //            input.focus();
        //            return;
        //        }
        //    }
        //    else if (input.hasClass('numeric')) {
        //        var i = Q.parseInteger(text);
        //        if (isNaN(i) || i > 32767 || i < 0) {
        //            Q.notifyError(Q.text('Validation.Integer'), '', null);
        //            input.val(oldText);
        //            input.focus();
        //            return;
        //        }
        //        value = i;
        //    }
        //    else {
        //        value = text;
        //    }

        //    // *** Update Weight, Amount etc on Pieces Change***
        //    if (field === fld.Pieces && value > 0) {

        //        if (item.ItemTypeId == 104 || item.ItemTypeId == 105) {
        //            item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
        //            item[field] = value;

        //            this.view.updateItem(id, item);
        //            this.view.refresh();
        //        }

        //    }
        //    let oldvalues = [];

        //    // *** Update Weight, Amount etc on Pieces Change***
        //    if (field === fld.Weight && value > 0) {


        //        if (item.ItemTypeId == 105) {

        //            item[field] = value;

        //            this.view.updateItem(id, item);
        //            this.view.refresh();
        //        }

        //    }
        //    if (field === fld.BomRate && value > 0) {
        //        item[field] = value;

        //        this.view.updateItem(id, item);
        //        this.view.refresh();
        //    }



        //    this.view.updateItem(id, item);
        //    this.view.refresh();

        //    if (input.hasClass('numeric'))
        //        value = Q.formatNumber(value, '0.00');

        //    if (input.hasClass('integer'))
        //        value = Q.formatNumber(value, '0');

        //    input.val(value).addClass('dirty');
        //}


        //public getEffectiveValue(item, field: any): any {
        //    var id = this.id(item);
        //    var pending = this.pendingChanges[id];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }
        //    return item[field];
        //}

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion



        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.ProductSelectGrid;
            buttons.pop();

            return buttons;
        }

    }
}